<template>
  <div>
    <div class="modal-overlay" @click="closeSaveStateModal" v-if="open"></div>
    <div class="rates-modal-container" :class="[open ? 'open' : 'closed']">
      <h1>Save Shipment State</h1>
      <label>Name
        <input @input="changeStateName" :value="stateName" type="text"/>
      </label>
      <div class="saved-state-buttons">
        <button v-if="currentState && currentState.name === stateName" class="btn btn-primary" @click="updateISState">Update</button>
        <button v-else class="btn btn-primary" @click="saveISState">Save</button>
        <button @click="closeSaveStateModal" class="btn">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {};
  },
  props: ["open", "currentState", "stateName"],
  methods: {
    closeSaveStateModal() {
      this.$emit("toggleSaveStateModal");
    },
    changeStateName(e){
      this.$emit("changeStateName", e.target.value)
    },
    saveISState() {
      this.$emit(
        "saveState"
      );
    },
    updateISState() {
      this.$emit(
        "updateState"
      );
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
}

td,
th {
  padding: 0.7rem;
}

tr {
  border-bottom: 1px solid black;
}

.open {
  opacity: 1;
  top: 50%;
  transition: 0.3s ease-in-out;
}

.closed {
  top: -100%;
  opacity: 0;
  transition: 0.3s ease-in-out;
}

.saved-state-buttons{
  display:flex;
  justify-content:space-around;
  align-items:center;
}


.rates-modal-container {
  position: fixed;
  z-index: 3;
  left: 50%;
  height: 150px;
  width: 300px;
  text-align: center;
  background: white;
  margin-left: -150px;
  border-radius: 20px;
  justify-content:center;
  margin-top: -75px;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

  label{
    margin-bottom: 17px;
  }

h1 {
  padding: .5rem;
  font-size:14px;
  margin-bottom: 15px;
  margin-top:-28px;
  background: lightgrey;
  border-bottom: 1px solid black;
}
</style>
